<template>
	<el-dialog
	  title="智能导入工具"
	  class="newDialog"
	  append-to-body
    top="25px"
	  :close-on-click-modal="false"
	  :visible.sync="dialogVisible"
	  width="1200px"
	  >
	  <div id='AIimport-c'>
	  	<div style="position: relative;">
        <div class='AIimport-c-header'>
          <el-tooltip :content="aiContent" placement="top" effect="light">
            <img
              :src="getAIPic()"
              alt=""
              :class="{runningInfo:isRunning}"
              @click="clickAI"
              @mouseenter="getAiSay"
            >
          </el-tooltip>
        	<div class='AIimport-c-header-textRoll'></div>
        </div>
        <div class="AIimport-c-progress" v-if="numbers>2">
          <div class="AIimport-c-progress-bar" :style="aiProgressBarConfig"></div>
        </div>
      </div>
	  	<div class="AIimport-c-table">
	  		<div class='AIimport-c-table-h'>
	  			<div>
            <adjustmentBtn
              text = "调整所有标红"
              :c_style="adjustmentBtnStyle"
              :isSuspends="isSuspends"
              v-if="nowLogType==='4'"
              @handleMouse="getIsHaveError"
              @handleClick="settingsAll"
            >
            </adjustmentBtn>
            <acc-btn
              text="重新智能识别"
              size='mini'
              v-if="nowLogType==='4'"
              @click="onceAgain"
              :disabled="this.isRunning"
            >
            </acc-btn>
            <!-- 只显示错误数据 -->
            <el-checkbox 
                v-model="checkedError" 
                style="margin-left: 20px;" 
                v-if="nowLogType==='4'"
                >
                只显示错误数据
            </el-checkbox>
          </div>
	  			<div class='AIimport-c-table-h-import'>
	  				<span class='AIimport-c-table-h-import-tip'>可选择任意平台导出excel文件</span>
	  				<el-button size='mini' type="text"  @click='handleDownload_MB'>参考模板</el-button>
	  				<span class='AIimport-c-table-h-import-btn' @click="importData">
	  					<img src="/static/img/uploadBtnIcon.png" alt="">
	  					<span>上传文件</span>
	  				</span>
	  			</div>
	  		</div>
	  		<div class='AIimport-c-table-c'>
	  			<list
	  				ref="tableList"
            @noError="()=>{ checkedError=false }"
            :checkedError="checkedError"
            @getIsHaveError="getIsHaveError"
            @getLog="getLog"
	  			></list>
	  		</div>
	  		<div class='AIimport-c-table-r'>
	  			<div class='AIimport-c-table-r-title'>导入规则</div>
	  			<div class='AIimport-c-table-r-item'>
	  				<span class='AIimport-c-table-r-item-t'>覆盖模式</span>
	  				<el-radio v-model="coverType" :label="1">
	  					全部导入（直接覆盖）
	  					<el-tooltip class="item" effect="light" content="以导入的科目+编号为准，直接覆盖系统原有科目，使用科目最新的配置。" placement="bottom">
					      <i class='el-icon-question'></i>
					    </el-tooltip>
	  				</el-radio>
					<el-radio v-model="coverType" :label="2">
						仅覆盖未使用过的科目/编码
						<el-tooltip class="item" effect="light"
            content="仅针对未使用的科目，以导入的科目+编号为准，直
              接覆盖系统原有科目，使用科目最新的配置，
              不会对已使用过（包括编号或科目名称任一被凭证占用）的科目进行覆盖。"
            placement="bottom">
					      <i class='el-icon-question'></i>
					    </el-tooltip>
					</el-radio>
	  			</div>
	  			<div class='AIimport-c-table-r-item'>
	  				<span class='AIimport-c-table-r-item-t'>追加模式</span>
            <el-radio v-model="coverType" :label="3">
            	仅导入系统中不存在科目/编码
            	<el-tooltip class="item" effect="light" content="仅会导入系统中科目+编号都不存在的科目，不会改变现有系统的科目配置。" placement="bottom">
                  <i class='el-icon-question'></i>
                </el-tooltip>
            </el-radio>
	  			</div>
	  		</div>
	  	</div>
      <!-- 底部按钮 -->
      <div class='AIimport-c-table-f'>
        <acc-btn text="删除" type="3" @click="deleteSelect"></acc-btn>
        <acc-btn @click="importSubject" :disabled="nowLogType!=='4'"></acc-btn>
      </div>
	  	<!-- 导入 -->
	  	<import-file ref="importFiles" @uploadSuccess="uploadSuccess"></import-file>
      <!-- 调整配置 -->
      <setting ref="settings" v-bind="$attrs" @settingBack="uploadSuccess"></setting>
      <ai-angry ref="aiAngrys" @success="aiNotAngry" @error="closeDialog"></ai-angry>
	  </div>
	</el-dialog>
</template>
<script>
	import list from "./list.vue"
	import importFile from "./importFile.vue"
	import setting from "./setting.vue"
	import aiAngry from "./aiAngry.vue"
	import adjustmentBtn from "./adjustmentBtn.vue"
	export default {
		components:{
			list,importFile,setting,aiAngry,adjustmentBtn
		},
		data() {
			return {
        checkedError:false,  // 只显示错误数据
        adjustmentBtnStyle:{
          marginRight:"10px"
        },
        aiProgressBarConfig:{
          height:"0px",
          background:""
        },
        isSuspends:true,  // 是否显示调整异常动画
        isAiNotAngry:false,  // 机器人是否在消减生气值
        nowDateTime:null,
        aiContent:"嘘...",
        nowLogType:null,
				coverType:1,
				dialogVisible:false,
				AI_Status:1, // 1等待上传；2识别中；3、识别失败需要修改；4识别成功
				isRunning:false,  // 是否开始
        numbers:0,
				defaultText:{
					id:999,
					type:0,
					text:"正在为您启动人工智能小A，请稍后...."
				},
        allTableData:{}, // 表格数据副本
				textArr:[],
        AiSay:[
          "小A觉得产品经理是天底下最坏的大坏蛋~~",
          "哇！你竟然发现我了！！！",
          "我是一个没有感情的机器人，但是自从遇到你，我爱了！",
          "人生真是寂寞如雪啊~~额..忘了我只是一个没有感情的机器人..",
          "生成我的代码我没办法决定，但是选择你，是我自己的决定！",
          "你是不是在想，我到底能说多少句话？",
          "我到底是男孩还是女孩呢？",
          "看到鼠标变成小手手你是不是想点我？",
        ]
			}
		},
    watch:{
      dialogVisible(val) {
        if(val) {
          this.$nextTick(()=>{
            this.$refs.tableList.getTable();
            let parentDom = document.getElementsByClassName("AIimport-c-header-textRoll")[0];
            parentDom.scrollTop = parentDom.scrollHeight;
          })
        }
      },
      numbers(val) {
        if(val<5) {
          this.aiContent = this.isAiNotAngry?"不生气了，不生气了，生气对身体不好~~":"别点脸！毕竟我是靠脸吃饭的~~";
        }else if(val<10) {
          this.aiContent = this.isAiNotAngry?"不生气了，不生气了，生气对身体不好~~":"这是一个正经的记账软件，别点了好吗？";
          this.aiProgressBarConfig.background = 'rgb(103, 194, 58)';
        }else if(val<15) {
          this.aiContent = this.isAiNotAngry?"不生气了，不生气了，生气对身体不好~~":"好吧，我佩服你的执着，但是你再点我就生气了！";
          this.aiProgressBarConfig.background = 'rgb(230, 162, 60)';
        }else if(val<20){
          this.aiContent = this.isAiNotAngry?"不生气了，不生气了，生气对身体不好~~":"我真的生气了！！！";
          this.aiProgressBarConfig.background = 'rgb(245, 108, 108)';
        }else {
          this.$refs.aiAngrys.dialogVisible = true;
        }

        this.aiProgressBarConfig.height = val*5 + "%";
      }
    },
		methods:{
      // 获取是否还有异常未修改
      getIsHaveError(val) {
        this.isSuspends = val;
      },
      // 怒气值消减函数
      aiNotAngry(data) {
        this.numbers--;
        if(this.numbers>0) {
          this.isAiNotAngry = true;
          setTimeout(()=>{ this.aiNotAngry() },200)
        }else {
          this.isAiNotAngry = false;
        }
      },
      closeDialog() {
        this.dialogVisible = false;
        this.$emit("angry",true)
      },
      // 点击机器人
      clickAI() {
        if(this.isRunning) {
          this.aiContent = "我工作的时候是很严肃的，别嬉皮笑脸！";
          return
        }
        if(this.isAiNotAngry) {
          return
        }
        this.numbers++
        if(this.nowDateTime) {
          clearTimeout(this.nowDateTime)
        }
        this.nowDateTime = setTimeout(()=>{ // 点击间隔超过3s重置
          if(this.numbers>=20) return;
          this.aiNotAngry();
        },3000)
      },
       // 获取机器语言
      getAiSay() {
        if(this.isRunning) {
          this.aiContent = "别碰我，我正在工作，出了差错你负责！";
          return
        }
        // 随机数字
        var num = Math.floor(Math.random() * 8);
        let text = this.AiSay[num];
        this.aiContent = text;
      },
      // 导入
      importSubject() {
        let tableListRef = this.$refs.tableList;
        let nowSelect = tableListRef.nowSelect;
        if(!nowSelect.length) return this.$message.warning("系统未检测到您的选择项！");
        this.isOk(
        nowSelect,
        ()=>{
          this.addDom({
            id:99,
            type:0,
            text:"系统正在为您导入科目，请稍后....."
          });
          // 成功通过
          let idArr =  nowSelect.map(i=> { return i.id } );
          let params = {
            ids:idArr.toString(),
            type:this.coverType
          }
          tableListRef.loading = true;
          this.$http.post('import/importSubject',params)
            .then(
                res=>{
                  tableListRef.loading = false;
                  if(res&&res.data.code=="1") {
                    this.$message.success(res.data.msg);
                    this.$emit("successImport",true)
                    this.dialogVisible = false;
                    this.addDom({
                      id:991,
                      type:1,
                      text:"已为您导入成功！"
                    });
                  }else {
                    this.addDom({
                      id:991,
                      type:2,
                      text:res.data.msg 
                    });
                  }
                }
            )
        },
        ()=>{
          this.$message.warning("系统检测到您的选项中有异常项未修改！")
        })


      },
      // 判断是否可导入
      isOk(arr,success,faild) {
        let isOk = true;
        if(arr&&arr.length) {
          for(var i =0;i<arr.length;i++) {
            if(arr[i].isAbnormal) {
              isOk = false;
              break;
            }
          }
        }
        if(isOk) {
          success();
        }else {
          faild();
        }
      },
      // 删除所有选择
      deleteSelect() {
        this.$refs.tableList.deleteAll();
      },
      // 调整所有标红
      settingsAll() {
         this.$refs.settings.dialogVisible = true;
      },
			// 导入
			importData() {
				this.$refs.importFiles.dialogVisible = true;
			},
      // 重新智能识别
      onceAgain() {
        this.$refs.tableList.handleDistinguish();
      },
      // 导入成功
      uploadSuccess() {
        this.$refs.tableList.getTable();
      },
			// 下载模板
			handleDownload_MB() { 
				let cid=sessionStorage.getItem('cid');
			  	let token=sessionStorage.getItem('token');
				window.location.href = this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token+"&templateName=科目模板.xls";
			},
      /**
       * 获取列表修改进程
       * 0、匹配失败；
       * 1、客户未上传列表，
       * 2、匹配表头成功
       * 3、客户智能识别完毕  需要执行动画
       * 4、已经识别完毕
       * 5、识别开场提示
       * */
      getLog(obj) {
        this.nowLogType = obj.type;
        switch(obj.type) {
          case "0":
            this.addDom({
              id:9991,
              type:2,
              text:"小A检测到您的表格表头有未匹配项，已为您标记，请及时修改哟！"
            });
            break;
          case "1":
            this.addDom({
              id:9992,
              type:0,
              text:"欢迎使用芒果智能导入，我是小A，请上传您的文件！"
            });
            break;
          case "2":
            this.addDom({
              id:9993,
              type:1,
              text:"恭喜您已成功匹配所有表头！请点击下方的智能匹配，小A自动为您匹配表格内容哟~"
            });
            break;
          case "3":
            if(obj.data&&obj.data.tableHead.length) {
              this.runningSatrt(obj.data.tableHead);
              this.allTableData = obj.data;  // 保存数据
            }
            break;
          case "4":
            this.addDom({
              id:9995,
              type:0,
              text:"温馨提示：可以导入已经修改完成的科目哟~~"
            });
            break;
          case "5":
            this.addDom({
              id:9996,
              type:0,
              text:"系统正在拉取数据，请稍后..."
            });
            break;
          default:
            break;
        }
      },
      // 执行识别动画
      runningSatrt(headList) {
        let textArrs = [];
        headList.forEach(i=>{
          if(i.props !== "fastSelect") {
            textArrs.push({
              id:i.id + "s",
              type:0,
              text:"正在识别" + i.label + "..."
            })
            textArrs.push({
              id:i.id,
              type:i.normal?2:1,
              text:i.label +"匹配" + (i.normal?"失败！":"成功！")
            })
          }
        })
        this.textArr = this.$deepClone(textArrs);
        this.running();  // 让我们跑起来
      },
      // 获取最新时间
      getNewData() {
        let date = this.$formart(new Date(),"yyyy-MM-dd hh:mm:ss");
        return date;
      },
			running() {
				if(this.isRunning) return;
				this.AI_Status=2;
				this.runstart(this.textArr,0);
				this.isRunning = true;
			},
			clear() {
				let parentDom = document.getElementsByClassName("AIimport-c-header-textRoll")[0];
				while (parentDom.firstChild) {
  				  parentDom.removeChild(parentDom.firstChild);
  				}

  				this.AI_Status = 1;
			},
			runstart(arr,index) {
				if(arr&&(arr.length>index)) {
					setTimeout(()=>{
						let data = arr[index];
						this.addDom(data,()=>{ this.runstart(arr,index+1) });
					},500)
				}else {
					this.isRunning = false;
					let datas = this.textArr.find(i=>{ return i.type===2 })
					this.AI_Status = datas?3:4;
          this.addDom({
            id:10086,
            type:datas?2:1,
            text:datas?"系统检测到有未识别表格内容，请您一键调整":"系统未检测到表格异常，针不戳！"
          });
          this.$refs.tableList.getTable();  // 优化方案提示---allTableData
				}
			},
			// 添加DOM
			addDom(data,callback) {
				let parentDom = document.getElementsByClassName("AIimport-c-header-textRoll")[0];
				let p = document.createElement('p');
				if(data.type==1) {  // 成功信息
					p.className ="AIimport-c-header-textRoll-default AIimport-c-header-textRoll-success"
				}else if(data.type==2) {  // 失败信息
					p.className ="AIimport-c-header-textRoll-default AIimport-c-header-textRoll-error"
				}else {  // 正常提示
					p.className ="AIimport-c-header-textRoll-default"
				}
        let pText = data.text + " --------------------- " + this.getNewData();
				let t = document.createTextNode(pText);
				p.appendChild(t);
				parentDom.appendChild(p);
				parentDom.scrollTop = parentDom.scrollHeight;
				if(callback) callback();
			},
			getAIPic() {
				let srcText = "";  // 默认
				switch (this.AI_Status) {
					case 2:
						srcText = "/static/img/AI-running.png";
						break;
					case 3:
						srcText = "/static/img/AI-warning.png";
						break;
					case 4:
						srcText = "/static/img/AI-success.png";
						break;
					default:
						srcText = "/static/img/AI-wait.png";  // 默认
						break;
				}
				return srcText;
			},
		}
	}
</script>
<style lang="less">
	/*AI动画*/
  @keyframes shake {
    0%,100% {
      transform: translateX(0);
    }
    10%,30%,50%,70%,90% {
      transform: translateX(-2px);
    }
    20%,40%,60%,80%,{
      transform: translateX(2px);
    }
  }
	 @keyframes scaleDraw {
		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			transform:scale(1);
			/*开始为原始大小*/
		}
		25% {
			transform:scale(1.1);
			/*放大1.1倍*/
		}
		50% {
			transform:scale(1);
		}
		75% {
			transform:scale(1.1);
		}
	}

	/*end---*/
	#AIimport-c {
		padding: 0 30px 30px;
		.AIimport-c-table {
			padding: 20px 30px;
			border: 1px dashed #D9D9D9;
			background: rgba(251, 251, 251, 0.66);
			margin-top: 20px;
      &-r {
      	&-title {
      		color: #000000;
      		font-weight: 600;
      	}
      	&-item {
      		margin-top: 20px;
      		&-t {
      			color: #269D7B;
      			margin-right: 15px;
      		}
      	}
      }
      &-f {
        text-align: center;
        margin-top: 40px;
      }

			&-c {
				margin:30px 0;
			}
			&-h {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				&-import {
					display: flex;
					align-items: center;
					&-tip {
						color: #666666;
						font-size: 12px;
						margin-right: 22px;
					}
					&-btn {
						margin-left: 22px;
						display: flex;
						align-items: center;
						padding: 4px 10px;
            cursor: pointer;
						border: 1px dashed #ACB7C3;
            &:hover {
              background: #eee;
            }
						img {
							width: 12px;
							height: 12px;
							margin-right:10px;
						}
						span {
							color: #269D7B;
						}
					}
				}
			}
		}
    .AIimport-c-progress {
      position: absolute;
      left: 10px;
      top: 5px;
      bottom: 5px;
      width: 8px;
      border-radius: 8px;
      border: 1px solid #ddd;
      &-bar {
        position: absolute;
        transition: height .5s;
        bottom: 0;
        width: 100%;
        border-radius: 8px;
      }
    }
		.AIimport-c-header {
			padding: 10px 0px 10px 24px;
			height: 80px;
			background: #F5F7FA;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			.runningInfo {
				animation: scaleDraw 2s infinite;
			}
			&-textRoll {
				height: 100%;
				flex: 1;
				margin-left: 15px;
				overflow: auto;
				padding-right: 24px;
				&-default {
					color: #909399;
					margin-bottom: 5px;
					&:last-child {
						margin-bottom:0;
					};
				}
				&-success {
					color: #67C23A;
				}
				&-error {
					color: #F56C6C;
				}
			}
			img {
				width: 60px;
				height: 60px;
        cursor: pointer;
        transition: all .2s;
				display: inline-block;
        user-select: none;
        &:hover {
          animation: shake 1s;
        }
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AIImport/index.vue